// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import INITIAL_STATE from '../orderCreation/initialState.json';

export type ServiceRequestDataType = Readonly<typeof INITIAL_STATE>;

export function _getRegisterInfoData(
    state: any,
    { payload }: { payload: any }
): ServiceRequestDataType {
    if (payload) {
        return {
            ...state,
        };
    }

    return INITIAL_STATE;
}

export function _getRegisterInfoDataSuccess(
    state: any,
    { payload }: { payload: any }
): ServiceRequestDataType {
    if (payload) {
        return {
            ...state,
            customerInfo: { ...payload },
        };
    }

    return INITIAL_STATE;
}

export function _getRegistrationSuccess(
    state: any,
    { payload }: { payload: any }
): ServiceRequestDataType {
    if (payload) {
        return {
            ...state,
            registration: { ...payload },
        };
    }

    return INITIAL_STATE;
}

export function _getJarvisDataSuccess(
    state: any,
    { payload }: { payload: any }
): ServiceRequestDataType {
    if (payload) {
        return {
            ...state,
            jarvis: { ...payload },
        };
    }

    return INITIAL_STATE;
}

export function resetRegistrationReducer(
    state: any,
    { payload }: { payload: any }
): ServiceRequestDataType {
    return {
        ...state,
        customerInfo: {},
    };
}